/**
 * Header navigation:
 *  - custom burger toggles a fullscreen mobile overlay (.is-open on .main-nav)
 *  - body scroll lock while open
 *  - any nav link / the CTA closes the menu
 *  - sticky "scrolled" state after 40px
 *
 * core/navigation is set to overlayMenu:"never", so it only renders the
 * horizontal list — all responsive behaviour lives here.
 */
export default function nav() {
  const navEl = document.querySelector('.main-nav');
  if (!navEl) return;

  const burger = navEl.querySelector('.nav-burger');
  const collapse = navEl.querySelector('.nav-collapse');

  const open = () => {
    navEl.classList.add('is-open');
    burger?.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  };
  const close = () => {
    navEl.classList.remove('is-open');
    burger?.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  };

  if (burger) {
    burger.addEventListener('click', () =>
      navEl.classList.contains('is-open') ? close() : open()
    );
  }

  // close when a link or the CTA is tapped
  // Chrome Android drops the anchor scroll while the menu closes, so same-page
  // #anchors are scrolled manually on the next frame (other links navigate as usual)
  collapse?.querySelectorAll('a').forEach((a) =>
    a.addEventListener('click', (e) => {
      close();
      const { hash, origin, pathname } = new URL(a.href, location.href);
      const target = hash.length > 1 && origin + pathname === location.origin + location.pathname
        ? document.getElementById(decodeURIComponent(hash.slice(1)))
        : null;
      if (!target) return;
      e.preventDefault();
      history.pushState(null, '', hash);
      requestAnimationFrame(() => target.scrollIntoView());
    })
  );

  // close on Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });

  // on resize: suppress the slide transition and close the menu on desktop
  let resizeTimer;
  window.addEventListener('resize', () => {
    document.documentElement.classList.add('nav-resizing');
    if (window.innerWidth >= 1070) close();
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(
      () => document.documentElement.classList.remove('nav-resizing'),
      200
    );
  });

  // Sticky state
  const onScroll = () =>
    navEl.classList.toggle('scrolled', window.scrollY > 40);
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
}
